import React, { FC }         from 'react';
import { Label, LabelProps } from 'semantic-ui-react';
import { IconProps }         from 'semantic-ui-react/dist/commonjs/elements/Icon';

import { capitalize }                        from '../../../util';
import { SemanticUIColor }                   from '../../../types/componentPropTypes';
import { SystemEvent }                       from '../../../types/events';
import { ENTITY_COLORIZATION, ENTITY_ICONS } from '../../../constants/ProductEnums';

interface ActivityCompletionTimingLabelProps extends LabelProps {
	value?: 'late-start' | 'late-completion' | 'normal' | 'early-start' | 'early-completion',
	
	onClick?( e: SystemEvent ): void
}

const defaultProps: ActivityCompletionTimingLabelProps = {
	value:   'normal',
	onClick: null,
}

const ActivityTimingLabel: FC<ActivityCompletionTimingLabelProps> = ( props ) => {
	
	let label = capitalize( props.value.split( '-' ).join( ' ' ) ),
	    icon, color;
	
	switch( props.value ){
		
		case 'late-start' :
		case 'late-completion' :
			color = ENTITY_COLORIZATION.ACTIVITIES.TIMING.LATE as SemanticUIColor;
			icon  = ENTITY_ICONS.ACTIVITIES.TIMING.LATE;
			
			break;
		case 'early-start' :
		case 'early-completion' :
			color = ENTITY_COLORIZATION.ACTIVITIES.TIMING.EARLY as SemanticUIColor;
			icon  = ENTITY_ICONS.ACTIVITIES.TIMING.EARLY;
			
			break;
		case 'normal':
			color = ENTITY_COLORIZATION.ACTIVITIES.TIMING.NORMAL as SemanticUIColor;
			icon  = ENTITY_ICONS.ACTIVITIES.TIMING.NORMAL;
			
			break;
	}
	
	return (
		
		<Label circular
		       { ...props }
		       basic
		       icon={ { ...( props.icon as IconProps ), name: icon, color } }
		       content={ label }
		       onClick={ props.onClick }/>
	);
};

ActivityTimingLabel.defaultProps = defaultProps;

export { ActivityTimingLabel }
